import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import {Placement} from 'react-bootstrap/types';
import {StringUtils} from "../utils/StringUtils";

interface TruncateProps {
    value? : string
    maxLength : number
    placement?: Placement
}

export const Truncate = ({value, maxLength, placement = "top"} : TruncateProps) =>
{
    if (value === undefined || value === null || value.length < maxLength)
    {
        return (
            <>{value}</>
        )
    }
    else {
        return (
            <OverlayTrigger
                placement={placement}
                overlay={
                    <Tooltip>
                        {value}
                    </Tooltip>
                }
            >
                <span>{StringUtils.truncate(value, maxLength)}</span>
            </OverlayTrigger>
        )
    }
}
